import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MenuFuncionCodes, PedidoRemito } from '../../../../../src/app/shared/model';
import { MenuFuncionService, PedidoService } from '../../../../../src/app/shared/services';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

@Component({
  selector: 'app-dialogVerRemito',
  templateUrl: 'dialogVerRemito.component.html',
  styleUrls: ['./dialogVerRemito.component.scss']
})

export class DialogVerRemitoComponent implements OnInit {

  public title: string;
  public buttonAcceptText: string;
  public buttonCancelText: string;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isRemitoItemsSearching: boolean = false;

  remitoId: number;
  item: PedidoRemito;

  constructor(
    private dialogRef: MatDialogRef<DialogVerRemitoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private menuService: MenuFuncionService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private pedidoService: PedidoService
  ) {

  }

  ngOnInit() {
    this.menuService.checkMenu(MenuFuncionCodes.PEDIDO_REMITO_LIST).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onDecline();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });

    // this.buttonAcceptText = 'Guardar';
    this.buttonCancelText = 'Cerrar';
  }

  loadView() {
    this.remitoId = this.data;
    this.loadEntity();
  }

  loadEntity() {
    if (this.remitoId != null && this.remitoId > 0) {
      this.isSearching = true;
      this.pedidoService.getRemito(0, this.remitoId).subscribe(data => {
        this.isSearching = false;
        this.item = data?.Result;

        if (this.item != null && this.item.Id > 0) {
          this.getRemitoItems(this.item.Id);
        }
        else
          this.sharedFunctions.showMessage("No se encontró el remito seleccionado", "Error");
      },
      (err: HttpErrorResponse) => {
        this.isSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
    else
      this.sharedFunctions.showMessage("Debe seleccionar un remito para continuar", "Error");
  }

  getRemitoItems(id: number) {
    this.isRemitoItemsSearching = true;
    this.pedidoService.getRemitoDetalle(0, id).subscribe(data => {
      this.isRemitoItemsSearching = false;
      if (this.item != null) {
        this.item.RemitoDetalle = data?.Result;
      }
    },
    (err: HttpErrorResponse) => {
      this.isRemitoItemsSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  isProcessing() {
    return (this.isSearching);
  }

  onDecline() {
    this.dialogRef.close(null);
  }
}
